module.exports = __webpack_public_path__ + "static/media/bannerP.7daa64c6.png";